<template>
  <span>
    <template>
      <v-card class="monitoring-card">
        <v-card-title>
          <v-flex xs12 class="panel-without-shadow">
            <v-expansion-panels>
              <v-expansion-panel key="1">
                <v-expansion-panel-header>
                  <a class="monitoring-header-text monitoring-header-params">
                    <v-icon>mdi-airplay</v-icon>
                    Параметры мониторинга
                  </a>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-combobox
                        v-model="lastInteractionsNum"
                        type="number"
                        :items="[5,10,20]"
                        :label="'Число отображаемых последних запросов к счётчику (макс '+lastInteractionsNumMax+')'"
                    />
                    <v-combobox
                        v-model="refreshPeriod"
                        type="number"
                        :items="[0,30,60]"
                        :label="'Частота обновления данных в сек (макс '+refreshPeriodMax+')'"
                    />
                  </v-card-text>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-chip-group
                v-model="monitorStatusSelect"
                active-class="primary--text"
            >
              <v-chip
                  v-for="monitorStatus in monitorStatuses"
                  :key="monitorStatus.value"
                  :value="monitorStatus.value"
              >
                {{ monitorStatus.text }}
              </v-chip>
            </v-chip-group>
            <v-switch
                v-model="showHidden"
                label="Отображать скрытые задания">
            </v-switch>
          </v-flex>
        </v-card-title>
        <v-data-table
            :items="filteredTasks"
            :headers="monitoringHeaders"
            fixed-header
            no-data-text="Нет заданий с ошибками"
            hide-default-footer
            disable-pagination
            :loading="loading"
            loading-text="Пожалуйста подождите"
            dense
        >
          <div slot="footer" class="data-table-footer"></div>
          <tr slot="item" slot-scope="props">
            <td>
              <span class="one-row">
                <router-link
                    :to="'/counters?search=' + props.item.counter_num"
                    title="Переход в раздел счетчики"
                >{{ props.item.counter_num }}</router-link>
                <a
                    class="external-link"
                    target="_blank"
                    :href="'/counters?search=' + props.item.counter_num"
                    title="Открыть раздел счетчики, в новой вкладке(окне)"
                ><v-icon>mdi-open-in-new</v-icon></a>
              </span>
            </td>
            <td class="one-row">
              <router-link
                  :to="'/points/' + props.item.point_id + '/scheduler'"
                  title="Переход в раздел Точки учета"
              >{{ props.item.point_name }}</router-link>
              <a
                  v-if="props.item.point_name"
                  class="external-link"
                  target="_blank"
                  :href="'/points/' + props.item.point_id + '/scheduler'"
                  title="Открыть раздел Точки учета, в новой вкладке(окне)"
              ><v-icon>mdi-open-in-new</v-icon></a>
            </td>
            <td>{{ props.item.point_address }}</td>
            <td>
              <template v-if="props.item.represents !== null">
                <template v-for="represent in props.item.represents">
                  <div class="one-row" :key="represent.name">
                    <router-link
                        :to="'/represents/' + represent.represent_id"
                        title="Переход в раздел Объекты учета"
                    >{{ represent.name }}</router-link>
                    <a
                        v-if="represent.represent_id"
                        class="external-link"
                        target="_blank"
                        :href="'/represents/' + represent.represent_id"
                        title="Открыть раздел Объекты учета, в новой вкладке(окне)"
                    ><v-icon>mdi-open-in-new</v-icon></a>
                  </div>
                </template>
              </template>
            </td>
            <td>
              <template v-if="props.item.last_values">
                <template v-for="item in props.item.last_values.slice().reverse()">
                  <v-icon
                      class="squares"
                      :color="item.success ? 'green' : 'red'"
                  >mdi-square</v-icon>
                </template>
              </template>
            </td>
            <td>
              {{ props.item.last_interaction_date | moment("DD/MM/YYYY HH:mm:ss") }}
            </td>
            <td class="one-row">
              <span class="action-btns">
                <v-btn
                    v-if="hideFromFailedTasks[props.item.counter_task_id]"
                    icon
                    title="Вернуть из скрытых"
                    class="mt-1"
                    @click="hideFromResults(props.item, true)"
                >
                  <v-icon color="grey darken-1">mdi-eye-off</v-icon>
                </v-btn>
                <v-btn
                    v-else
                    icon
                    title="Скрыть из результатов на 1 час"
                    class="mt-1"
                    @click="hideFromResults(props.item, false)"
                >
                  <v-icon color="grey darken-4">mdi-eye</v-icon>
                </v-btn>
                <v-btn
                    icon
                    title="Журнал выполнения"
                    class="mt-1"
                    @click="viewCounterTaskLog(props.item)"
                >
                  <v-icon color="grey darken-1">fas fa-file-alt</v-icon>
                </v-btn>
              </span>
            </td>
          </tr>
        </v-data-table>
      </v-card>
      <v-bottom-sheet v-model="showLog">
        <task-logs :task="log_task"/>
      </v-bottom-sheet>
    </template>
  </span>
</template>

<script>
import axios from 'axios'
import TaskLogs from '../shared-components/TaskLogs'
import Vue from 'vue'

export default {
  name: 'Tasks',
  components: {
    TaskLogs
  },
  data() {
    return {
      tasks: [],
      hideFromFailedTasks: {},
      refreshPeriod: 0,
      refreshPeriodDefault: 0,
      refreshPeriodMin: 10,
      refreshPeriodMax: 600,
      log_task: {},
      execInterval: null,
      loading: false,
      showLog: false,
      lastInteractionsNum: 10,
      lastInteractionsNumDefault: 10,
      lastInteractionsNumMax: 100,
      monitoringHeaders: [
        {text: 'Номер счётчика', value: 'counter_num'},
        {text: 'Наименование ТУ', value: 'point_name'},
        {text: 'Адрес ТУ', value: 'address'},
        {text: 'Объекты', value: 'represents'},
        {text: 'Статус последних заданий', value: 'last_tasks'},
        {text: 'Дата последнего задания', value: 'last_interaction_date'},
        {text: 'Действия', value: 'actions'}
      ],
      monitorStatuses: [
        {text: 'Пауза из-за ошибок', value: 'PAUSED_FAILED'},
        {text: 'Работающие с перебоями', value: 'UNSTABLE'},
        {text: 'Остановленные с ошибками', value: 'STOPPED_FAILED'}
      ],
      monitorStatusSelect: 'PAUSED_FAILED',
      showHidden: false,
      search: ''
    }
  },
  computed: {
    filteredTasks() {
      const res = []
      const currDatetime = new Date()
      this.tasks.forEach((val) => {
        const existed = this.hideFromFailedTasks[val.counter_task_id]
        if (this.showHidden || existed === undefined || existed < currDatetime) {
          res.push(val)
          if (existed && existed < currDatetime) {
            delete this.hideFromFailedTasks[val.counter_task_id]
            localStorage.hideFromFailedTasks = JSON.stringify(this.hideFromFailedTasks)
          }
        }
      })
      return res
    }
  },
  watch: {
    refreshPeriod(newVal, oldVal) {
      if (newVal > this.refreshPeriodMax) {
        this.refreshPeriod = this.refreshPeriodMax
        return
      }
      if (newVal != 0 && newVal < this.refreshPeriodMin) {
        this.refreshPeriod = this.refreshPeriodMin
        return
      }
      if (newVal === oldVal) {
        return
      }
      this.runPeriodicRefresh()
      localStorage.monitoringRefreshPeriod = newVal
    },
    lastInteractionsNum(newVal, oldVal) {
      if (newVal > this.lastInteractionsNumMax) {
        this.lastInteractionsNum = this.lastInteractionsNumMax
        return
      }
      if (newVal === oldVal) {
        return
      }
      this.getFailedTasks()
      localStorage.lastInteractionsNum = newVal
    },
    monitorStatusSelect() {
      this.getFailedTasks()
    }
  },
  mounted() {
    this.runPeriodicRefresh()
    if (localStorage.monitoringRefreshPeriod) {
      this.refreshPeriod = localStorage.monitoringRefreshPeriod
    }
    if (localStorage.lastInteractionsNum) {
      this.lastInteractionsNum = localStorage.lastInteractionsNum
    } else {
      this.getFailedTasks()
    }
  },
  methods: {
    getFailedTasks() {
      this.loading = true
      axios.get(`/api/monitoring/`,
          {params: { interactions_num: this.lastInteractionsNum, mts: this.monitorStatusSelect}})
          .then((response) => {
            this.loading = false
            this.tasks = response.data
          })
          .catch((err) => {
            this.loading = false
            console.log(err)
          })
    },
    viewCounterTaskLog(item) {
      this.showLog = true
      this.log_task = item
    },
    runPeriodicRefresh() {
      clearInterval(this.execInterval)
      if (this.refreshPeriod != 0) {
        this.execInterval = setInterval(() => {
          this.getFailedTasks()
        }, this.refreshPeriod * 1000)
      }
    },
    hideFromResults(item, isShow) {
      if (isShow) {
        Vue.delete(this.hideFromFailedTasks, item.counter_task_id)
      } else {
        const currDatetime = new Date()
        Vue.set(this.hideFromFailedTasks, item.counter_task_id, currDatetime.setHours(currDatetime.getHours() + 1));
      }
      localStorage.hideFromFailedTasks = JSON.stringify(this.hideFromFailedTasks)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card.monitoring-card {
  position: unset;

  .monitoring-header-text {
    font-size: 14px;
    color: rgba(0, 0, 0, .87);
  }

  .monitoring-header-filter > .v-icon {
    color: #8599b7;
  }

  .monitoring-header-params > .v-icon {
    color: #b5cb9f;
  }

  .v-data-table {
    position: absolute;
    height: calc(100% - 80px);
    right: 0;
    left: 0;
  }

  .v-data-table__wrapper {
    max-height: 100%;
    border-top: 1px solid #e0d8d8;
    border-bottom: 1px solid #e0d8d8;
  }

  table {
    border-collapse: collapse;
  }

  th, td {
    border-right: 1px solid #e0d8d8;
  }
}

.panel-without-shadow {
  font-weight: normal;

  .v-expansion-panels {
    max-width: 800px;

    .v-expansion-panel {
      margin-top: 0;
    }
  }

  .v-expansion-panel:before {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  .v-expansion-panel:after {
    content: none !important;
  }

  .v-expansion-panel-header {
    min-height: auto !important;
    padding: 0 24px 0 0;
  }

  .v-expansion-panel-header__icon {
    display: none;
  }

  .v-expansion-panel-content__wrap {
    padding: 4px 18px 10px;
  }

  .v-card__text {
    padding: 10px 0 0;
  }

  .row > div {
    padding: 0;
  }
}

.one-row {
  white-space: nowrap;
}

.data-table-footer {
  border-top: solid rgb(224, 216, 216);
  border-width: 0.5px;
}

.squares {
  letter-spacing: -5px !important;
}

.action-btns {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/spa/Monitoring.vue